import React from 'react';
import { IProps } from './interfaces';

const KrCancellations: React.FC<IProps> = ({
  size = 32,
  color = '#FF6900',
  className,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6016_2)">
        <path
          d="M16 32C7.18 32 0 24.82 0 16C0 7.18 7.18 0 16 0C24.82 0 32 7.18 32 16C32 24.82 24.82 32 16 32ZM16 1.83C8.19 1.83 1.83 8.19 1.83 16C1.83 23.81 8.18 30.17 16 30.17C23.82 30.17 30.17 23.81 30.17 16C30.17 8.19 23.81 1.83 16 1.83Z"
          fill={color}
        />
        <path
          d="M23.02 23.63C22.86 23.63 22.71 23.57 22.59 23.45L8.56 9.42C8.32 9.18 8.32 8.79 8.56 8.56C8.8 8.33 9.18 8.32 9.42 8.56L23.45 22.59C23.69 22.83 23.69 23.22 23.45 23.45C23.33 23.57 23.17 23.63 23.02 23.63Z"
          fill={color}
        />
        <path
          d="M8.98 23.63C8.82 23.63 8.67 23.57 8.55 23.45C8.31 23.21 8.31 22.82 8.55 22.59L22.58 8.56C22.82 8.32 23.2 8.32 23.44 8.56C23.68 8.8 23.68 9.19 23.44 9.42L9.41 23.45C9.29 23.57 9.13 23.63 8.98 23.63Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_6016_2">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default KrCancellations;
